import clsx from 'clsx';
import React, {forwardRef, RefObject} from 'react';

export type IconSize = '2xs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | string;

export interface SvgIconProps extends React.SVGAttributes<SVGElement> {
  children?: React.ReactNode;
  size?: IconSize | null;
  color?: string;
  title?: string;
  fill?: string;
  ref?: RefObject<SVGSVGElement | null>;
  strokeWidth?: number;
}

export const SvgIcon = forwardRef<SVGSVGElement, SvgIconProps & {attr?: {}}>(
  (props, ref) => {
    const {
      attr,
      size,
      title,
      className,
      color,
      style,
      children,
      viewBox,
      width,
      height,
      fill = 'fill-current',
      strokeWidth = 2, // only used by lucide icons
      ...svgProps
    } = props;

    return (
      <svg
        aria-hidden={!title}
        focusable={false}
        xmlns="http://www.w3.org/2000/svg"
        viewBox={viewBox || '0 0 24 24'}
        strokeWidth={strokeWidth}
        {...attr}
        {...svgProps}
        className={clsx(
          'inline-block shrink-0 transition-icon select-none',
          fill,
          className,
          getSizeClassName(size),
        )}
        style={{
          color,
          ...style,
        }}
        ref={ref}
        height={height || '1em'}
        width={width || '1em'}
      >
        {title && <title>{title}</title>}
        {children}
      </svg>
    );
  },
);

function getSizeClassName(size?: IconSize | null) {
  switch (size) {
    case '2xs':
      return 'icon-3.5';
    case 'xs':
      return 'size-4';
    case 'sm':
      return 'size-5';
    case 'md':
      return 'size-6';
    case 'lg':
      return 'size-8';
    case 'xl':
      return 'size-10';
    default:
      return size;
  }
}
